import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit} from '@angular/core';
import {CertificateInterface, SpecialistViewInterface} from '@interfaces/specialist.interface';
import {SpecialistDataFlowService} from '../services/specialist-data-flow.service';
import {UploadedFile} from '@interfaces/file.interface';
import {PreviewModalService} from '@services/preview-modal.service';

@Component({
    selector: 'app-specialist-view-tab-nk',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: 'specialist-view-tab-nk.component.html'
})

export class SpecialistViewTabNkComponent implements OnChanges {
    @Input() specialist: SpecialistViewInterface;

    public certificates: CertificateToShow[] = [];

    constructor(
        private dataService: SpecialistDataFlowService,
        private previewService: PreviewModalService,
    ) {}

    ngOnChanges() {
        this.prepareToShow();
    }

    onAddClick() {
        this.dataService.addNk$.next();
    }

    showCertificate(certificate: CertificateInterface) {
        const files: UploadedFile[] = [];

        if (certificate.file && certificate.file.file_url) {
            files.push(certificate.file);
        }

        if (certificate.file_back && certificate.file_back.file_url) {
            files.push(certificate.file_back);
        }

        this.previewService.show({
            title: 'Удостоверение по неразрушающему контролю (НК)',
            contentBefore: `<p>Номер удостоверения: ${certificate.number}</p>`,
            files: files
        });
    }

    hasCertificate() {
        return Boolean(this.specialist && this.specialist.certificate_nk && this.specialist.certificate_nk.length);
    }

    private prepareToShow() {
        if (!this.specialist || !this.specialist.certificate_nk || !this.specialist.certificate_nk.length) {
            return;
        }

        /**
         * Проверяем для удостоверения, одинаковые ли объекты и даты окончания для всех методов удостоверения
         * @type {CertificateToShow[]}
         */
        this.certificates = this.specialist.certificate_nk.map(cert => {
            let isEqual = false;

            if (cert.methods && cert.methods.length) {
                // Берем первый метод как эталон для сравнения
                const example = cert.methods[0].objects_string + cert.methods[0].expiration_date;
                isEqual = cert.methods.every(m => {
                    return (m.objects_string + m.expiration_date) === example;
                });
            }

            return {
                ...cert,
                isMethodsEqual: isEqual
            };
        });
    }
}

/**
 * Удостоверение для отображения чуть чуть расширяет базовое.
 */
interface CertificateToShow extends CertificateInterface {
    isMethodsEqual: boolean;  // true, если все методы удостоверения имеют одинаковую дату окончания и объекты
}
